import { pathgen } from 'object-path-generator';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
export const useSetNotificationStatusV2TestIds = pathgen('useSetNotificationStatusV2TestIds');
export const useSetNotificationStatusV2 = function useSetNotificationStatusV2() {
    let { onSuccess, onError } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { t: commonTexts } = useLocaleKeys('common');
    const { mutate, isLoading, error } = useMutationState({
        mutationFn: (args)=>api.notification.setNotificationStatusV2(args),
        toasts: {
            successMessage: commonTexts.toasts.notificationSettingsUpdatedSuccessfully(),
            successTestId: useSetNotificationStatusV2TestIds.SuccessToast()
        },
        onSuccess,
        onError
    });
    return {
        setStatus: mutate,
        isLoading,
        error
    };
};
